//@flow
import React from 'react';
import {connect} from 'react-redux';
import {openTable} from '../../../data/modules/ui';
//import AdditionalInfo from './AdditionalInfo/AdditionalInfo';
import {AdditionalInfoSubSection} from './AdditionalInfo/AdditionalInfo';
import SubSectionList from './SubSectionList/SubSectionList';
import SectionHeader from './SectionHeader/SectionHeader';
import omit from 'lodash.omit';
import s from './SummarySubSection.less';

type Props = {
  data: Object,
  title: string,
  totalFob: number,
  openTable: Function,
};

const SummarySubSection = (props: Props) => {
  const showSubSection =
    props.title !== 'Tooling Cost' &&
    props.title !== 'Profit Cost';
  return (
    <div className={`col-xs-4`}>
      <div className={`shadowBox ${s.section}`}>
        <SectionHeader
          title={props.title}
          cost={props.data.sectionSummary.cost}
        />
        {showSubSection &&
          <div className={`${s.sectionData}`}>
            <SubSectionList
              title = {props.title}
              totalFOB={props.totalFob}
              percentFOB={props.data.sectionSummary.percentFob}
              sectionCost={props.data.sectionSummary.cost}
              sectionSummary={props.data.sectionSummary.subSections}
            />
          </div>}
        <AdditionalInfoSubSection
          sectionTitle={props.title}
          additionalInfo={omit (props.data.sectionSummary, [
            'subSections',
            'cost',
          ])}
        />
      </div>
    </div>
  );
};

const mapDispatchToProps = {openTable};

export default connect (null, mapDispatchToProps) (SummarySubSection);



// WEBPACK FOOTER //
// ./src/components/SummarySubSections/SummarySubSection/SummarySubSection.js